import { render } from "./Books.vue?vue&type=template&id=0b4c41f2&scoped=true"
const script = {}

import "./Books.vue?vue&type=style&index=0&id=0b4c41f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b4c41f2"

export default script